import React from 'react';

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
  xl: 'h-16 w-16 border-4',
};

const Spinner = ({
  size = 'md',
  color = 'brand',
  className = '',
}) => {
  const colorClasses = {
    brand: 'border-brand-500',
    white: 'border-white',
    primary: 'border-brand-500',
    dark: 'border-black dark:border-white',
  };

  return (
    <div
      className={`
        animate-spin rounded-full
        border-t-transparent
        ${sizes[size]}
        ${colorClasses[color] || colorClasses.brand}
        ${className}
      `}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

// Full page spinner overlay
export const SpinnerOverlay = ({ message = 'Loading...' }) => (
  <div className="fixed inset-0 z-99999 flex items-center justify-center bg-white/80 dark:bg-boxdark/80">
    <div className="flex flex-col items-center gap-4">
      <Spinner size="lg" />
      {message && (
        <p className="text-body dark:text-bodydark">{message}</p>
      )}
    </div>
  </div>
);

// Inline spinner with optional text
export const SpinnerInline = ({ message, size = 'sm' }) => (
  <span className="inline-flex items-center gap-2">
    <Spinner size={size} />
    {message && <span>{message}</span>}
  </span>
);

export default Spinner;
